import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import {
  claimsAiFallbackList,
  readClaimsAiModelList,
  type ClaimsAiModelList,
} from "../lib/claimsAiModels";

export interface ClaimsAiModelsState {
  loading: boolean;
  list: ClaimsAiModelList;
  // True when the call failed and the static fallback list is showing.
  failed: boolean;
}

// Loads the selectable Gemini models from the claims-ai-models function.
export function useClaimsAiModels(): ClaimsAiModelsState {
  const [state, setState] = useState<ClaimsAiModelsState>({
    loading: true,
    list: claimsAiFallbackList(),
    failed: false,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await supabase.functions.invoke("claims-ai-models");
        if (cancelled) return;
        if (error) throw error;
        const { list, failed } = readClaimsAiModelList(data);
        setState({ loading: false, list, failed });
      } catch {
        if (!cancelled) {
          setState({ loading: false, list: claimsAiFallbackList(), failed: true });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
